function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ContextActions } from '@deephaven/components';
import { assertNotNull } from '@deephaven/utils';
import React, { useCallback, useMemo, useState } from 'react';
import FileList from "./FileList.js";
import { FileListItem } from "./FileListItem.js";
import { DEFAULT_ROW_HEIGHT } from "./FileListUtils.js";
import { isDirectory } from "./FileStorage.js";
import SHORTCUTS from "./FileExplorerShortcuts.js";
import "./FileExplorer.css";
import FileUtils from "./FileUtils.js";
import FileListItemEditor from "./FileListItemEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Component that displays and allows interaction with the file system in the provided FileStorage.
 */
export function FileListContainer(props) {
  var _props$isMultiSelect = props.isMultiSelect,
    isMultiSelect = _props$isMultiSelect === void 0 ? false : _props$isMultiSelect,
    focusedPath = props.focusedPath,
    _props$showContextMen = props.showContextMenu,
    showContextMenu = _props$showContextMen === void 0 ? false : _props$showContextMen,
    onCreateFile = props.onCreateFile,
    onCreateFolder = props.onCreateFolder,
    onCopy = props.onCopy,
    onDelete = props.onDelete,
    onMove = props.onMove,
    onRename = props.onRename,
    onSelect = props.onSelect,
    onSelectionChange = props.onSelectionChange,
    table = props.table,
    _props$rowHeight = props.rowHeight,
    rowHeight = _props$rowHeight === void 0 ? DEFAULT_ROW_HEIGHT : _props$rowHeight,
    _props$validateRename = props.validateRename,
    validateRename = _props$validateRename === void 0 ? () => Promise.resolve() : _props$validateRename;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    renameItem = _useState2[0],
    setRenameItem = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItems = _useState4[0],
    setSelectedItems = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    focusedItem = _useState6[0],
    setFocusedItem = _useState6[1];
  var handleSelectionChange = useCallback(newSelectedItems => {
    setSelectedItems(newSelectedItems);
    onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(newSelectedItems);
  }, [onSelectionChange]);
  var handleFocusChange = useCallback(newFocusedItem => {
    setFocusedItem(newFocusedItem);
  }, []);
  var handleCopyAction = useCallback(() => {
    if (focusedItem) {
      onCopy === null || onCopy === void 0 || onCopy(focusedItem);
    }
  }, [focusedItem, onCopy]);
  var handleDeleteAction = useCallback(() => {
    if (selectedItems.length > 0) {
      onDelete === null || onDelete === void 0 || onDelete(selectedItems);
    }
  }, [onDelete, selectedItems]);
  var handleNewFileAction = useCallback(() => {
    onCreateFile === null || onCreateFile === void 0 || onCreateFile();
  }, [onCreateFile]);
  var handleNewFolderAction = useCallback(() => {
    if (focusedItem) {
      onCreateFolder === null || onCreateFolder === void 0 || onCreateFolder(FileUtils.getPath(focusedItem.filename));
    }
  }, [focusedItem, onCreateFolder]);
  var handleRenameAction = useCallback(() => {
    if (focusedItem) {
      setRenameItem(focusedItem);
    }
  }, [focusedItem]);
  var handleRenameCancel = useCallback(() => {
    setRenameItem(undefined);
  }, []);
  var handleRenameSubmit = useCallback(newName => {
    if (renameItem) {
      onRename === null || onRename === void 0 || onRename(renameItem, newName);
      setRenameItem(undefined);
    }
  }, [onRename, renameItem]);
  var actions = useMemo(() => {
    if (renameItem) {
      // While renaming, we don't want to enable any of the context actions or it may interfere with renaming input
      return [];
    }
    var result = [];
    if (onCreateFile) {
      result.push({
        title: 'New File',
        description: 'Create new file',
        action: handleNewFileAction,
        group: ContextActions.groups.medium
      });
    }
    if (onCreateFolder) {
      result.push({
        title: 'New Folder',
        description: 'Create new folder',
        action: handleNewFolderAction,
        group: ContextActions.groups.medium
      });
    }
    if (onCopy) {
      result.push({
        title: 'Copy File',
        description: 'Copy the selected file',
        action: handleCopyAction,
        group: ContextActions.groups.low,
        disabled: focusedItem == null || isDirectory(focusedItem)
      });
    }
    if (onDelete && selectedItems.length > 0) {
      result.push({
        title: 'Delete',
        description: 'Delete',
        shortcut: SHORTCUTS.FILE_EXPLORER.DELETE,
        action: handleDeleteAction,
        group: ContextActions.groups.low
      });
    }
    if (onRename) {
      result.push({
        title: 'Rename',
        description: 'Rename',
        shortcut: SHORTCUTS.FILE_EXPLORER.RENAME,
        action: handleRenameAction,
        group: ContextActions.groups.low,
        disabled: focusedItem == null
      });
    }
    return result;
  }, [handleCopyAction, handleDeleteAction, handleNewFileAction, handleNewFolderAction, handleRenameAction, focusedItem, onCopy, onCreateFile, onCreateFolder, onDelete, onRename, selectedItems, renameItem]);
  var validateRenameItem = useCallback(newName => {
    assertNotNull(renameItem);
    return validateRename(renameItem, newName);
  }, [renameItem, validateRename]);
  var renderItem = useCallback(itemProps => {
    var item = itemProps.item;
    if (renameItem && renameItem.filename === item.filename) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        _jsx(FileListItem, _objectSpread(_objectSpread({}, itemProps), {}, {
          children: /*#__PURE__*/_jsx(FileListItemEditor, {
            item: item,
            validate: validateRenameItem,
            onSubmit: handleRenameSubmit,
            onCancel: handleRenameCancel
          })
        }))
      );
    }
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/_jsx(FileListItem, _objectSpread({}, itemProps));
  }, [handleRenameCancel, handleRenameSubmit, renameItem, validateRenameItem]);
  return /*#__PURE__*/_jsxs("div", {
    className: "file-list-container",
    children: [table != null && /*#__PURE__*/_jsx(FileList, {
      onMove: onMove,
      onSelect: onSelect,
      onSelectionChange: handleSelectionChange,
      onFocusChange: handleFocusChange,
      renderItem: renderItem,
      rowHeight: rowHeight,
      table: table,
      isMultiSelect: isMultiSelect,
      focusedPath: focusedPath
    }), showContextMenu && /*#__PURE__*/_jsx(ContextActions, {
      actions: actions
    })]
  });
}
FileListContainer.displayName = 'FileListContainer';
export default FileListContainer;
//# sourceMappingURL=FileListContainer.js.map